import React from "react";
import { withStyles } from "@material-ui/core/styles";
import styles from "../styles";
import localStyles from "./styles";
import { Grid } from "@material-ui/core";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import Select from "../../../../../common/StyledSelect";
import { compose } from "recompose";
import { HOOK_TYPE_OPTION } from "../../constants";
import constants from "../../DispatchPanel/constants";
import { postData } from "../../../../../../api/componentAPIs";
import MESSAGES from "../../../../../../appMessages";
import Events from "../../../../../../utilities/EventEmitter";
import { withSnackbar } from "notistack";
import isEqual from "lodash/isEqual";
import { canAddTrailer, getArrivedAtStopId, getTrailerOptions } from "../utils";
import Action from "./Action";

class TrailerHook extends React.Component {
  constructor(props) {
    super(props);
    this.attachedTrailers = this.getCurrentTrailers();
    this.state = {
      hookTrailersError: [],
      hookTrailers: [this.getNewHookedTrailer()],
      selectedHookType: HOOK_TYPE_OPTION.Trailer,
      hookTypes: this.getHookTypes(),
      trailerListOptions: [],
    };
  }

  componentDidMount() {
    Events.on("trailerHooked", this.trailerHookedStatus);
    Events.on("bobtailProcessed", this.bobtailProcessedStatus);
    this.generateTrailerOptions();
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.routeData, this.props.routeData)) {
      this.attachedTrailers = this.getCurrentTrailers();
      this.setState({ hookTypes: this.getHookTypes() });
    }
    if (prevProps.trailerList != this.props.trailerList) {
      const hookTrailersError = this.getErrors();
      this.generateTrailerOptions(hookTrailersError);
    }
  }

  componentWillUnmount() {
    Events.off("trailerHooked", this.trailerHookedStatus);
    Events.off("bobtailProcessed", this.bobtailProcessedStatus);
  }

  generateTrailerOptions = (hookTrailersError=[]) => {
    const trailerListOptions = getTrailerOptions(this.props.trailerList, this.props.showTrailerScac);
    this.setState({trailerListOptions, hookTrailersError});
  }

  checkStatus = (data, type) => {
    const { success } = data;
    if (success) {
      this.onTrailerHookSucceed(type);
    } else {
      this.onTrailerHookFailed(type);
    }
  };

  trailerHookedStatus = (data) => {
    this.checkStatus(data, HOOK_TYPE_OPTION.Trailer);
  };

  bobtailProcessedStatus = (data) => {
    this.checkStatus(data, HOOK_TYPE_OPTION.Bobtail);
  };

  getCurrentTrailers = () => {
    return this.props.currentDriverRoutes
      .filter(
        (route) =>
          route.trailerNumber &&
          route.trailerNumber !== constants.TRAILER_NUMBER_FOR_BOBTAIL
      )
      .map(({ trailerNumber, trailerScac }) => ({
        trailerNumber,
        trailerScac,
      }));
  };

  isBobtail = () => {
    return this.props.currentDriverRoutes.filter(
      (route) => route.trailerNumber === constants.TRAILER_NUMBER_FOR_BOBTAIL
    ).length;
  };

  getHookTypes = () => {
    const isBobtailDisabled =
      this.attachedTrailers.length !== 0 || this.isBobtail();
    return Object.keys(HOOK_TYPE_OPTION).map((key) => ({
      label: HOOK_TYPE_OPTION[key],
      value: key,
      isDisabled: key === HOOK_TYPE_OPTION.Bobtail ? isBobtailDisabled : false,
    }));
  };

  handleTrailerNumberChange = (trailerIndex) => (value) => {
    const trailerNumber = value?.value;
    const { trailerId, trailerStatus, trailerScac, isStraightTruck } = value ?? {};
    const hookTrailers = this.state.hookTrailers;
    hookTrailers[trailerIndex] = {
      ...hookTrailers[trailerIndex],
      trailerNumber,
      trailerId,
      trailerStatus,
      trailerScac,
      isStraightTruck
    };
    this.setState({ hookTrailers }, () =>
      this.updateTrailerNumberErrors({
        trailerIndex,
        trailerId,
        trailerStatus,
        isStraightTruck
      })
    );
  };

  updateTrailerNumberErrors = ({
    trailerIndex,
    trailerId,
    trailerStatus,
    isStraightTruck
  }) => {
    this.setState((prevState) => ({
      hookTrailersError: prevState.hookTrailersError.map(
        (hookTrailerError, index) => {
          if (index === trailerIndex) {
            return this.checkValidTrailerNumber(trailerId, trailerStatus, isStraightTruck);
          }
          return hookTrailerError;
        }
      ),
    }));
  };

  getNewHookedTrailer = () => ({
    trailerNumber: null,
    trailerScac: null,
    dollyNumber: null,
    dollyScac: null,
  });

  addNewTrailer = () => {
    const newHookedTrailerData = this.getNewHookedTrailer();
    this.setState((state) => ({
      hookTrailers: [...state.hookTrailers, newHookedTrailerData],
      hookTrailersError: [...state.hookTrailersError, null],
    }));
  };

  removeHookTrailer = () => {
    const { hookTrailers, hookTrailersError } = this.state;
    this.setState({
      hookTrailers: [...hookTrailers.splice(0, hookTrailers.length - 1)],
      hookTrailersError: [...hookTrailersError.splice(0, hookTrailersError.length - 1)],
    });
  };

  checkValidTrailerNumber = (trailerId, trailerStatus, isStraightTruck) => {
    const { allowedTrailerStatusesToHook } = this.props;
    if (!trailerId) {
      return "* Required";
    }
    const selectedTrailers =
      this.state.hookTrailers?.filter(
        (trailer) => trailerId && trailer.trailerId === trailerId
      ) ?? [];
    if (selectedTrailers?.length > 1) {
      return "Duplicate trailer entry";
    } else if (trailerStatus && !allowedTrailerStatusesToHook.includes(trailerStatus)) {
      return `Valid trailer status: ${
        allowedTrailerStatusesToHook.length === 0 ? 'None' : allowedTrailerStatusesToHook.join(', ')
      }`;
    } else if (isStraightTruck) {
      return "Straight truck cannot be hooked";
    }
    return null;
  };

  getTrailerNumberErrors = () => {
    return this.state.hookTrailers.map(({ trailerId, trailerStatus, isStraightTruck }) =>
      this.checkValidTrailerNumber(trailerId, trailerStatus, isStraightTruck)
    );
  };

  getErrors = () => {
    return this.state.selectedHookType === HOOK_TYPE_OPTION.Trailer
      ? this.getTrailerNumberErrors()
      : [];
  };

  getPayloadDataByHookType = () => {
    const selectedHookType = this.state.selectedHookType;
    const { userData, routeData } = this.props;
    let requestData = {
      terminalCode: userData.userProfile.terminal.code,
      driverId: routeData.driverId,
      dispatchId: routeData.dispatchId,
    };
    if (selectedHookType === HOOK_TYPE_OPTION.Bobtail) {
      return {
        apiName: HOOK_TYPE_OPTION.Bobtail,
        requestData
      };
    }
    requestData = {
      ...requestData,
      equipments: this.state.hookTrailers.reduce((hookedTrailers, hookTrailer) => {
        if (!hookTrailer.trailerId) {
          return hookedTrailers;
        }
        return [...hookedTrailers, {
          trailerNumber: hookTrailer.trailerNumber ?? null,
          trailerScac: hookTrailer.trailerScac ?? null,
          dollyNumber: null, //backend using same model for trailer/dolly hook so they need these fields as well
          dollyScac: null,
        }]
      }, []),
      arrivedStopId: getArrivedAtStopId(routeData)
    }
    return {
      requestData,
      apiName: "TrailerHook",
    };
  }

  onHookTrailer = () => {
    const errors = this.getErrors();
    this.setState({
      hookTrailersError: errors,
    });
    const hasValidInputs = Object.values(errors).every(
      (v) => v === null
    );
    if (!hasValidInputs) {
      return;
    }
    const { requestData, apiName } = this.getPayloadDataByHookType();
    this.props.showHideLoader(true);
    postData(apiName, requestData)
      .then((response) => {
        if (response?.status !== 204) {
          this.onTrailerHookFailed(this.state.selectedHookType, response.status);
        }
      })
      .catch(() => {
        this.onTrailerHookFailed(this.state.selectedHookType);
      });
  };

  onTrailerHookFailed = (type, statusCode) => {
    this.props.showHideLoader(false);
    if (statusCode === 403) {
      return;
    }
    const msg =
      type === HOOK_TYPE_OPTION.Trailer
        ? MESSAGES.TRAILER_HOOKED.FAILURE
        : MESSAGES.BOBTAIL_PROCESSED.FAILURE;
    this.props.enqueueSnackbar(msg, {
      variant: "error",
    });
  };

  clearSelectedTrailers = () => {
    this.setState({
      hookTrailers: [this.getNewHookedTrailer()],
      hookTrailersError: [],
    });
  }

  onTrailerHookSucceed = (type) => {
    const msg =
      type === HOOK_TYPE_OPTION.Trailer
        ? MESSAGES.TRAILER_HOOKED.SUCCESS
        : MESSAGES.BOBTAIL_PROCESSED.SUCCESS;
    this.props.enqueueSnackbar(msg, {
      variant: "success",
    });
    this.props.showHideLoader(false);
    this.clearSelectedTrailers();
  };

  render() {
    const attachedTrailersCount = this.attachedTrailers.length;
    const { classes, isLoading, maxAllowedTrailerCount, routeData } = this.props;
    const { hookTrailers, selectedHookType, trailerListOptions } = this.state;
    const isAddTrailerDisabled = canAddTrailer(
      attachedTrailersCount,
      hookTrailers.length,
      maxAllowedTrailerCount
    );
    const isLastEntry = hookTrailers.length === 1;
    const isBobtailSelected = selectedHookType === HOOK_TYPE_OPTION.Bobtail;
    const isCurrentStraightTruck = routeData.trailer?.isStraightTruck;
    const isSectionDisabled = (attachedTrailersCount >= maxAllowedTrailerCount) || isCurrentStraightTruck;
    return (
      <Grid
        container
        className={`${classes.containerStyle} ${
          isSectionDisabled ? classes.sectionDisabled : null
        }`}>
        <Grid item xs={12}>
          <div className={classes.sectionTitle}>Trailer Hook</div>
          <div className={classes.flexRow}>
            <Select
              textFieldProps={{
                id: 'HookType',
                label: 'Hook Type',
                variant: 'outlined'
              }}
              value={this.state.selectedHookType}
              onChange={(val) =>
                this.setState({
                  selectedHookType: val?.value
                })
              }
              isNotClearable={true}
              data={this.state.hookTypes}
              rootClass={classes.selectRoot}
            />
          </div>
          {!isBobtailSelected &&
            this.state.hookTrailers.map((hookTrailer, hookTrailerIndex) => (
              <div className={classes.searchRow} key={hookTrailer.trailerId}>
                <Select
                  value={hookTrailer.trailerNumber}
                  data={trailerListOptions}
                  onChange={this.handleTrailerNumberChange(hookTrailerIndex)}
                  rootClass={classes.selectRootHook}
                  textFieldProps={{
                    id: 'hookTrailersList',
                    label: 'Trailer Number',
                    variant: 'outlined',
                    helperText: isSectionDisabled
                      ? ''
                      : this.state.hookTrailersError[hookTrailerIndex]
                  }}
                  error={
                    !isSectionDisabled && Boolean(this.state.hookTrailersError[hookTrailerIndex])
                  }
                />
              </div>
            ))}
          <Action
            onAdd={this.addNewTrailer}
            onCancel={this.removeHookTrailer}
            onSubmit={this.onHookTrailer}
            disabledCancel={isLoading || isLastEntry || isSectionDisabled}
            disabledAdd={isLoading || isAddTrailerDisabled || isSectionDisabled}
            disableSubmit={isLoading || isSectionDisabled}
            isBobtailSelected={isBobtailSelected}
          />
        </Grid>
      </Grid>
    );
  }
}

export default compose(
  withSnackbar,
  withUserProfile,
  withStyles(
    (theme) => ({
      ...styles(theme),
      ...localStyles(theme),
    }),
    { withTheme: true }
  )
)(TrailerHook);
